import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import foremostShortLogo from '@src/img/logos/foremost-short-logo.svg';

const isStaging = process.env.FRONTEND_ENV !== 'production';
const envName = isStaging ? process.env.FRONTEND_ENV : '';

const Logo = ({ sidebarOpen }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: sidebarOpen ? '10px' : 0,
            justifyContent: sidebarOpen ? 'flex-start' : 'center',
            p: sidebarOpen ? '12px 14px 8px' : '12px 8px 8px',
            transition: 'all 0.2s ease',
        }}
    >
        <Box
            alt="Foremost Logo"
            component="img"
            src={foremostShortLogo}
            sx={{
                width: 28,
                height: 28,
                flexShrink: 0,
                display: 'block',
            }}
        />

        {sidebarOpen ? (
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: '13.5px',
                        fontWeight: 700,
                        letterSpacing: '-0.01em',
                        lineHeight: 1.2,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: 'text.primary',
                    }}
                >
                    Producer News Admin
                </Typography>
                {envName ? (
                    <Typography
                        variant="caption"
                        sx={{
                            display: 'block',
                            fontSize: '11px',
                            color: 'text.secondary',
                            lineHeight: 1.2,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {envName}
                    </Typography>
                ) : null}
            </Box>
        ) : null}
    </Box>
);

Logo.propTypes = {
    sidebarOpen: PropTypes.bool,
};

export default Logo;
